import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PostVenditaSection = styled.section`
  padding: 2rem 0;

  .page-header {
    margin-bottom: 3rem;
    text-align: center;
  }

  h2 {
    color: #333;
    font-weight: 600;
    font-size: 1.7rem;
    margin-bottom: 1rem;
  }

  hr {
    border: 0;
    height: 2px;
    background: linear-gradient(to right, transparent, #00a651, transparent);
    margin: 2rem auto;
    width: 60%;
    opacity: 0.3;
  }

  .actions-container {
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 2rem;
    margin-top: 3rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
  }
`;

export const ActionButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.1rem 2.5rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  min-width: 250px;
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  border: 2px solid transparent;
  box-shadow: 0 4px 12px rgba(0, 166, 81, 0.2);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 166, 81, 0.35);
    color: white;
  }

  &:active {
    transform: translateY(-2px);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 400px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    min-width: 220px;
  }
`;

export const PostVenditaType = styled.section`
  .post-vendita-styles {
    padding: 20px 100px;
  }

  .option-button {
    margin: 5px;
    padding: 20px;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--greenia-color);
    background-color: rgba(0, 200, 0, 0);
    border: 2px solid var(--greenia-color);
    border-radius: 20px;
    cursor: pointer;
    transition: 0.3s;
  }

  .option-button:hover {
    background-color: rgba(0, 200, 0, 0.3);
  }

  .option-button-icon > * {
    height: 60px;
    width: 60px;
  }

  .option-button-text {
    font-size: 25px;
  }

  .post-vendita-text {
    font-size: 30px;
  }
`;
